import { FolderType } from "@/types/productTypes";
import { produce } from "immer";
import { StateCreator } from "zustand";

import fetchDb from "../utils/customRequestFunction";

export interface FolderStoreState {
   folders: FolderType[];
   selectedFolder: number | null;
   setSelectedFolder: (folderId: number | null) => void;
   fetchFolders: () => Promise<void>;
   fetchFolder: (id: number) => Promise<FolderType | undefined>;
   createFolder: (data: Partial<FolderType>) => Promise<void>;
   updateFolder: (id: number, data: Partial<FolderType>) => Promise<void>;
   deleteFolder: (id: number) => Promise<void>;
}

export const createFolderSlice: StateCreator<FolderStoreState> = (set) => ({
   folders: [],
   selectedFolder: null,
   setSelectedFolder: (folderId) => {
      set(
         produce((state: FolderStoreState) => {
            state.selectedFolder = folderId;
         })
      );
   },
   fetchFolders: async () => {
      try {
         const fetchedFolders = await fetchDb.get("/api/folder");
         set(
            produce((state: FolderStoreState) => {
               state.folders = fetchedFolders;
            })
         );
      } catch (error) {
         console.error("Error fetching folders:", error);
      }
   },
   fetchFolder: async (id: number) => {
      try {
         const folder = await fetchDb.get(`/api/folder/${id}`);
         return folder;
      } catch (error) {
         console.error("Error fetching folder:", error);
         return undefined;
      }
   },
   createFolder: async (data: Partial<FolderType>) => {
      try {
         const newFolder = await fetchDb.post("/api/folder", data);
         set(
            produce((state: FolderStoreState) => {
               state.folders.push(newFolder);
            })
         );
      } catch (error) {
         console.error("Error creating folder:", error);
      }
   },
   updateFolder: async (id: number, data: Partial<FolderType>) => {
      try {
         const updatedFolder = await fetchDb.patch(`/api/folder/${id}`, data);
         set(
            produce((state: FolderStoreState) => {
               const index = state.folders.findIndex(
                  (folder) => folder.id === id
               );
               if (index !== -1) {
                  state.folders[index] = updatedFolder;
               }
            })
         );
      } catch (error) {
         console.error("Error updating folder:", error);
      }
   },
   deleteFolder: async (id: number) => {
      try {
         await fetchDb.delete(`/api/folder/${id}`);
         set(
            produce((state: FolderStoreState) => {
               state.folders = state.folders.filter(
                  (folder) => folder.id !== id
               );
            })
         );
      } catch (error) {
         console.error("Error deleting folder:", error);
      }
   },
});
